import { useTranslation } from 'react-i18next';
import { Link, useRouteMatch } from 'react-router-dom';

import ClassDropDown from 'components/Header/components/ClassDropDown/ClassDropDown';
import useRouterHelper from 'hooks/useRouterHelper';

import AssignmentHeader from './EditAndDelete/EditAndDeleteButtons';
import IStudyQuery from '../../../IURLQuery';

import './TeachingStructureHeader.scoped.scss';

const TeachingStructureHeader = ({ callback }) => {
  const { t } = useTranslation();
  const { query, routePush } = useRouterHelper<IStudyQuery>();
  const { params } = useRouteMatch<{
    id: string;
  }>();
  const parentId = params.id;
  const handleAddNewTeachingStructureItem = () => {
    return () => {
      routePush({
        search: {
          newItem: true,
        },
        removeSearch: ['edit'],
      });
    };
  };

  const createUrlForNewItem = (type: string) => {
    return `/study/form?subject=${parentId}&type=${type}&title=${query?.title}&chapter=${
      query?.lesson as string
    }&class=${query.class as string}`;
  };

  const printAddChapterButton = () => {
    if (query && query.type?.length && query.type !== 'structure') {
      return <></>;
    }

    return (
      <div onClick={handleAddNewTeachingStructureItem()} className="add-new text">
        +
      </div>
    );
  };

  return (
    <div className="flex align-center gap-1">
      {query && (
        <>
          <div>{printAddChapterButton()}</div>
          <AssignmentHeader callback={callback} />
          {query?.type === 'structure' && (
            <ClassDropDown
              value={t('study:add_new').toString()}
              styleDropDown={{ right: 0, left: 'auto', padding: '7px' }}
              spanStyle={{ fontWeight: '600' }}
              containerStyle={{ width: '165px', height: '40px' }}
              icon={''}
            >
              <div className="flex flex-col">
                <Link
                  className="btn nowrap text-medium no-underline add-text"
                  to={createUrlForNewItem('material')}
                >
                  {t('study:add_material')}
                </Link>
                {/* <Link
                  className="btn nowrap text-medium no-underline add-text"
                  to={`/study/form?subject=${parentId}&type=quiz&title=${query?.title}&chapter=${
                    query?.lesson as string
                  }`}
                >
                  {t('study:add_quiz')}
                </Link> */}
                <Link
                  className="btn nowrap text-medium no-underline add-text"
                  to={createUrlForNewItem('task')}
                >
                  {t('study:add_task')}
                </Link>
              </div>
            </ClassDropDown>
          )}
        </>
      )}
    </div>
  );
};

export default TeachingStructureHeader;
